import { render, staticRenderFns } from "./bulk-message-template-type-cards.vue?vue&type=template&id=dee9955c&scoped=true&"
import script from "./bulk-message-template-type-cards.vue?vue&type=script&lang=js&"
export * from "./bulk-message-template-type-cards.vue?vue&type=script&lang=js&"
import style0 from "./bulk-message-template-type-cards.vue?vue&type=style&index=0&id=dee9955c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee9955c",
  null
  
)

export default component.exports